import { m } from "@/paraglide/messages";
import type { Tool } from "../index";

export const od260Tool: Tool = {
  id: "od260-concentration",
  name: () => m.od_tool_name(),
  description: () => m.od_tool_description(),
  icon: "🔬",
  basePath: "/od260-concentration",
  status: "stable",
  tags: [
    "bioinformatics",
    "dna",
    "rna",
    "science",
    "spectrophotometry",
    "concentration",
  ],
};
